export default {
  PMO_CONFIG_FACTORY_CODE: 'factoryCode',
  PMO_CONFIG_OFFICE_CODE: 'managingOffice',
  PMO_CONFIG_OFFICE_NAME: 'managingOfficeName',
  PMO_CONFIG_USER_ID: 'managingUserID',
  PMO_CONFIG_USER_NAME: 'managingUser',
  PMO_CONFIG_USER_EMAIL: 'managingUserEmail',
  PMO_CONFIG_MODIFIED_BY: 'modifiedBy',
  PMO_CONFIG_MODIFIED_DATE: 'modifiedDate',
  PMO_CONFIG_DIVISION_CODE: 'divisionCode'
};
